import Typesetter from '.'

module.exports = Typesetter
